<script lang="ts" setup>
import { ref } from "vue";
import { useFetch} from "@/helpers/composables/useFetch";
import { route } from "ziggy-js";
import NProgress from "nprogress";
import { useSettingsStore } from "@/store/settings";

const { setNotificationMessage } = useSettingsStore();

let resaleCertificate = ref();
let resaleCertificateFile = ref();

let beginUpload = () => {
    resaleCertificate.value.click();
};

let message = defineModel('uploadMessage', {
    type: Object,
    default: ()=>({})
});

let uploadResaleCertificate = (e) => {
    resaleCertificateFile.value = e.target.files[0];
    let formData = new FormData();
    formData.append("file", resaleCertificateFile.value);
    useFetch(route("endpoint.uploadResaleCertificate"), {
        beforeFetch: (ctx) => {
            NProgress.start();
            ctx.options.headers = {
                ...ctx.options.headers,
                'Accept': 'application/json',
            }
            return ctx;
        },
        afterFetch: (ctx) => {
            NProgress.done();
            if(ctx.response.ok){
                message.value = {
                    text: 'Resale Certificate uploaded successfully',
                    success: true
                };
                setNotificationMessage({
                    message: 'Resale Certificate uploaded successfully',
                    type: 'success'
                });
            }else{
                message.value = {};
            }
        },
        onFetchError: (ctx) => {
            NProgress.done();
            message.value = {
                text: ctx?.data?.message ?? 'Resale Certificate upload failed',
                success: false
            }
            setNotificationMessage({
                message: ctx?.data?.message ?? 'Resale Certificate upload failed',
                type: 'error'
            });
        }
    }).post(formData).json();
};

let props = defineProps({
    tag: {
        type: String,
        default: "a"
    }
});
</script>
<template>
   
    <component :is="tag"
    v-bind="$attrs" @click.prevent="beginUpload"><slot></slot></component>
    <input type="file" ref="resaleCertificate" style="display: none" @change="uploadResaleCertificate">
    
</template>